import React from 'react';
import {
  DataGrid as MuiDataGrid,
  GridColDef,
  GridRowSelectionModel,
  GridRowParams,
} from '@mui/x-data-grid';
import { Box } from '@mui/material';

interface DataGridProps {
  columns: GridColDef[];
  rows: any[];
  loading?: boolean;
  checkboxSelection?: boolean;
  rowSelectionModel?: GridRowSelectionModel;
  onRowSelectionModelChange?: (selection: GridRowSelectionModel) => void;
  onRowClick?: (params: GridRowParams) => void;
  pageSize?: number;
  pageSizeOptions?: number[];
  autoHeight?: boolean;
  getRowHeight?: () => 'auto' | number;
  sx?: any;
}

export default function DataGrid({
  columns,
  rows,
  loading = false,
  checkboxSelection = false,
  rowSelectionModel,
  onRowSelectionModelChange,
  onRowClick,
  pageSize = 10,
  pageSizeOptions = [5, 10, 25, 50, 100],
  autoHeight = true,
  getRowHeight = () => 'auto',
  sx = {},
}: DataGridProps) {
  return (
    <Box sx={{ width: '100%', ...sx }}>
      <MuiDataGrid
        autoHeight={autoHeight}
        getRowHeight={getRowHeight}
        columns={columns}
        rows={rows}
        loading={loading}
        checkboxSelection={checkboxSelection}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={onRowSelectionModelChange}
        onRowClick={onRowClick}
        initialState={{
          pagination: {
            paginationModel: { pageSize },
          },
        }}
        pageSizeOptions={pageSizeOptions}
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 1,
            borderColor: 'divider',
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: 'background.paper',
            borderBottom: 2,
            borderColor: 'divider',
          },
          '& .MuiDataGrid-virtualScroller': {
            backgroundColor: 'background.paper',
          },
          width: '100%',
          ...sx,
        }}
      />
    </Box>
  );
}
